import classNames from 'classnames'

import { ProfileUsersWidgetItem } from '../../../../../Widget'
import { getIsApplicantDecisionUserIconsShown } from '../ApplicantDecisionPanel.utils'

import * as styles from './ApplicantDecisionUser.module.css'

function ApplicantDecisionUser({ isMuted, value }) {
  return (
    <span
      className={classNames(styles.ApplicantDecisionUser, {
        [styles.muted]: isMuted,
      })}
    >
      {/* TODO: mock applicants carry mock users, so the user is not a link until they are served */}
      <ProfileUsersWidgetItem
        blocked
        AdditionalInfo={null}
        isNeedToShowIcons={getIsApplicantDecisionUserIconsShown}
        value={value}
      />
    </span>
  )
}

export default ApplicantDecisionUser
